/**
 * Serbian overrides for one person's page and the Dnevnik's additions.
 *
 * Ekavica — *poslednja*, *ocena*, *meseca*, *mesta*, *izmene*, *ovde*, *pre*
 * — and the *da* + present the standard prefers: *ne može da se prijavi*.
 * Latin script, like the rest of the application.
 */

import type { PeopleSlice } from '../bs/people'

export const people: Partial<PeopleSlice> = {
  'people.lastSignIn': 'Poslednja prijava u sistem',
  'people.mes.unfollowed.explain':
    'KaproMES je {when} prestao da šalje ovu osobu. Nalog je ostao kakav je bio — deaktivirajte ga ovde ako je osoba otišla.',

  'people.action.edit': 'Izmeni',
  'people.action.deactivate.self': 'Ne možete da deaktivirate sopstveni nalog.',
  'people.activate.body': 'Ponovo može da se prijavi istom lozinkom ili karticom kao pre.',
  'people.deactivate.body':
    'Odmah se odjavljuje sa svih uređaja i ne može da se prijavi dok nalog ponovo ne aktivirate. Prijave, zadaci i obilasci ostaju.',
  'people.save.failed': 'Promena nije sačuvana. Pokušajte ponovo.',

  'people.tile.rating': 'Ocena',
  'people.tile.rating.unranked': 'Bez mesta na listi · {month}',
  'people.tile.rating.none': 'Ovog meseca još nema ocene',
  'people.tile.signIns.detail': 'Neuspešne: {failed}',

  'people.activity.explain':
    '„Nalog" su izmene naloga ove osobe, ko god da ih je napravio. „Radnje" je ono što je ova osoba sama radila — u administraciji, na prijavama i obrascima. Prijave, zadaci i obilasci su samo iz pogona koje vidite.',
  'people.activity.empty.description':
    'Ovde se pojavljuju prijave u sistem, prijave, zadaci, 5S obilasci i izmene naloga.',

  'admin.log.chip.event': 'Izmena: {value}',
}
